// 我的分组
import {
    validate50WordsRequired,
    validateRequired,
} from '@/utils/form-validate.js'
/* showType：table 只在表格中显示
*  dom: 存在 dom 的才会被 form 渲染
*  id : 当 showType 设置为 'form' 并且没有提供 dom 参数时，table 和 form 都不会被显示，隐藏参数传递。
* */
export default {
    name: '我的分组',
    tableData: [], /*表格数据*/
    labelWidth: '120px',
    rowKey: 'id',
    batchDel: true,
    selectable: true,
    exportApi: '/flowable/group/export',
    /*删除配置项*/
    delProp: {
        id: 'id',
        label: 'name'
    },
    statusProp: {
        label: 'name'
    },
    permissions:{
        add:'flowable:group:add',
        edit:'flowable:group:edit',
        export:'flowable:group:export',
        remove:'flowable:group:remove'
    },
    /*表格配置项*/
    columns: [
        {
            prop: 'id',
            label: '序号',
            width: '100',
            showType: 'table',
        },
        {
            prop: 'name',
            label: '分组名称',
            minWidth: '200',
            more: true,
            showType: 'table',
            defaultValue: '',
            dom: {
                __config__: {
                    tag: 'el-input',
                    span: 24,
                    rules: {required: true, validator: validate50WordsRequired}
                },
                // 标签属性，需要渲染到标签上
                __attrs__: {
                    clearable: true,
                    maxlength: 50,
                }
            }
        },
        {
            prop: 'groupType',
            label: '分组类型',
            defaultValue: 'myDept',
            dom: {}
        },
        {
            prop: 'groupIds', // 用于有分组合并来的 ids回显
            label: '分组IDs',
            defaultValue: [], // 保存时需要转为string
            dom: {}
        },
        {
            prop: 'userIds',
            label: '分组成员',
            width: '120',
            align: 'center',
            showType: 'table',
            defaultValue: '',
            dom: {
                __config__: {
                    rules: {required: true,message:'请选择分组成员', trigger: 'change'}
                }
            }
        },
        {
            prop: 'sysUsers',
            label: '组员列表',
            defaultValue: [],
            dom: {}
        },
        {
            prop: 'remark',
            label: '备注',
            minWidth: '170px',
            showType: 'table',
            defaultValue: '',
            dom: {
                __config__: {
                    tag: 'el-input'
                },
                __attrs__: {
                    clearable: true,
                    type: 'textarea',
                    maxlength: '200'
                }
            }
        },
        {
            prop: 'createTime',
            label: '创建时间',
            width: '180',
            showType: 'table'
        }
    ]
}
